<template>
<div class='h-flex h-flex-space-between h-flex-dir-column'>
    <img :src='requireImage("forgot-password.svg")'>
    <div class='h-text-center h-mb-20'>
        <div class='b-base-title h-mt-10 h-fw-700'>
            {{ $t('AUTH.FORGET_PASSWORD.TITLE') }}
        </div>
        <p class='h-mt-10 h-mb-20 h-text-center h-fw-400'>
            {{ $t('AUTH.FORGET_PASSWORD.ASIDE') }}
        </p>
    </div>
    <div>
        <FwFormInput
            class='h-mb-25'
            :fieldHasError='fieldHasErrorByRule(email, EMAIL, emailRules)'
            labelType='label-thin'
            :title='$t(`AUTH.SIGN_UP.FORM.EMAIL.LABEL`)'>
            <FwInput
                :value='email'
                type='text'
                name='text'
                inputStyle='gray'
                placeholder='adresse@email.com'
                :error='getFieldErrorTextByRule(email, EMAIL, emailRules)'
                iconRight='edit'
                @update='value => email = value'
                @input='clearServerErrorsBase(EMAIL)'
                @blur='addCurrentInputToValidateArray(EMAIL)'>
            </FwInput>
        </FwFormInput>
    </div>

    <div class='h-flex h-flex-center h-width-100p'>
        <FwButton
            class='h-mt-30'
            :disabled='!isFormValid'
            borderRadiusType='small-border'
            @click='onSubmit'>
            {{ $t('AUTH.FORGET_PASSWORD.BUTTON') }}
        </FwButton>
    </div>
</div>
</template>

<script lang='ts'>
import { Component, Emit, mixins } from 'vue-facing-decorator';
import { EMAIL } from '@/helpers/auth';
import { useValidation } from '@/composables/useValidation';
import AuthMixin from '@/mixins/auth';
import type { ServerErrorsType } from '@/types/Validation';

@Component
export default class ForgotPasswordPage extends mixins(AuthMixin) {
    [EMAIL]: string = '';
    EMAIL: string = EMAIL;
    emailRules: string[] = ['required', 'email'];

    validation = useValidation();

    get fieldHasErrorByRule() {
        return this.validation.fieldHasErrorByRule;
    }

    get getFieldErrorTextByRule() {
        return this.validation.getFieldErrorTextByRule;
    }

    get clearServerErrorsBase() {
        return this.validation.clearServerErrorsBase;
    }

    get addCurrentInputToValidateArray() {
        return this.validation.addCurrentInputToValidateArray;
    }

    get isFormValid() {
        return this.validation.emailValidator({ value: this[EMAIL] });
    }

    @Emit('onSubmit')
    onSubmit() {
        return {
            [EMAIL]: this[EMAIL],
        };
    }
}
</script>

<style lang='sass'>

</style>
